<template>
  <div>
    <basic-container>
      <avue-crud
        :option="tableOption"
        :data="tableData"
        :table-loading="tableLoading"
        :page="page"
        ref="crud"
        @search-change="searchChange"
        @search-reset="searchReset"
        @refresh-change="refreshChange(page)"
        @selection-change="handleSelectionChange"
        @size-change="pageSizeChange"
        @current-change="pageChange"
      >
        <template slot="menuLeft">
          <el-button type="text" size="small" icon="el-icon-plus" plain @click.stop="handleAdd">新增套餐</el-button>
          <el-button
            type="text"
            icon="el-icon-delete"
            size="small"
            plain
            @click.stop="handleDel"
          >删除</el-button>
        </template>

        <template slot-scope="scope" slot="menu">
          <el-button type="text" size="small" icon="el-icon-edit" plain @click.stop="handleEdit(scope.row)">编辑</el-button>
          <el-button type="text" size="small" icon="el-icon-view" plain @click.stop="handleView(scope.row)">查看</el-button>
          <el-button type="text" size="small" icon="el-icon-date" plain @click.stop="handleSchedule(scope.row)">配置工期</el-button>
          <el-button type="text" size="small" icon="el-icon-delete" plain @click.stop="handleDelRow(scope.row)">删除</el-button>
        </template>
      </avue-crud>
    </basic-container>

    <!-- 新增 / 编辑套餐弹窗 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      append-to-body
      :close-on-click-modal="false"
      @close="handleDialogClose"
    >
      <el-form ref="comboForm" :model="comboForm" :rules="formRules" label-width="110px">
        <!-- 防水项目选择（用于加载阶段列表） -->
        <el-form-item label="防水项目" prop="projectId">
          <el-select
            v-model="comboForm.projectId"
            placeholder="请选择防水项目（加载阶段数据）"
            filterable
            :disabled="isView"
            style="width: 100%"
            @change="handleProjectChange"
          >
            <el-option
              v-for="project in projectList"
              :key="project.id"
              :label="project.name"
              :value="project.id"
            ></el-option>
          </el-select>
          <div v-if="stageLoading" style="margin-top:4px; color:#409eff; font-size:12px;">
            <i class="el-icon-loading"></i> 正在加载阶段数据…
          </div>
        </el-form-item>

        <el-form-item label="套餐名称" prop="name">
          <el-input v-model="comboForm.name" placeholder="请输入套餐名称" :disabled="isView"></el-input>
        </el-form-item>

        <el-form-item label="排序值" prop="sort">
          <el-input-number
            v-model="comboForm.sort"
            :min="0"
            :max="9999"
            :step="1"
            :disabled="isView"
            placeholder="越小越靠前，默认 0"
          ></el-input-number>
        </el-form-item>

        <!-- 组合阶段选择区域 -->
        <el-form-item label="组合阶段" prop="childIds">
          <div class="stage-panel">
            <!-- 面板头部 -->
            <div class="stage-panel__header">
              <div class="stage-panel__header-left">
                <i class="el-icon-s-operation"></i>
                <span>从该项目中勾选阶段进行组合</span>
              </div>
              <div class="stage-panel__header-right" v-if="allStages.length && !isView">
                <el-button type="text" size="mini" @click="handleSelectAllStages">
                  <i :class="isAllStagesSelected ? 'el-icon-circle-close' : 'el-icon-circle-check'"></i>
                  {{ isAllStagesSelected ? '取消全选' : '全选' }}
                </el-button>
              </div>
            </div>

            <!-- 阶段表格（可勾选） -->
            <el-table
              v-if="allStages.length"
              ref="stageTable"
              :data="allStages"
              size="small"
              highlight-current-row
              @selection-change="handleStageSelectionChange"
              :row-class-name="stageRowClassName"
              style="width: 100%"
              max-height="320"
            >
              <el-table-column type="selection" width="42" align="center" :selectable="() => !isView"></el-table-column>
              <el-table-column label="阶段名称" min-width="160">
                <template slot-scope="scope">
                  <div class="stage-row__name">
                    <span class="stage-row__sort-badge">{{ scope.row.sort }}</span>
                    <span>{{ scope.row.stageName }}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="costGrouping" label="分组" width="70" align="center">
                <template slot-scope="scope">
                  <el-tag size="mini" effect="plain">{{ scope.row.costGrouping }}</el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="price" label="拿货价" width="110" align="right">
                <template slot-scope="scope">
                  <span class="stage-row__price">¥{{ scope.row.price }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="threshold" label="阈值" width="80" align="center"></el-table-column>
              <el-table-column label="表单字段" width="90" align="center">
                <template slot-scope="scope">
                  <span class="stage-row__field-count">{{ (scope.row.formFields || []).length }} 项</span>
                </template>
              </el-table-column>
            </el-table>

            <!-- 空状态 -->
            <div v-if="!allStages.length && !stageLoading" class="stage-panel__empty">
              <i class="el-icon-folder-opened"></i>
              <p>{{ comboForm.projectId ? '该项目暂无阶段数据' : '请先选择防水项目以加载阶段数据' }}</p>
            </div>

            <!-- 加载中 -->
            <div v-if="stageLoading" class="stage-panel__loading">
              <i class="el-icon-loading"></i>
              <span>正在加载阶段数据…</span>
            </div>

            <!-- 底部汇总 -->
            <div class="stage-panel__footer" v-if="allStages.length">
              <div class="stage-panel__footer-left">
                <span class="stage-panel__count">
                  已选 <b>{{ comboForm.childIds.length }}</b> / {{ allStages.length }} 个阶段
                </span>
              </div>
              <div class="stage-panel__footer-right">
                <span>合计拿货价：</span>
                <span class="stage-panel__total-price">¥{{ computedTotalPrice }}</span>
              </div>
            </div>
          </div>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button v-if="!isView" type="primary" :loading="submitLoading" @click="handleSubmit">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 阶段工期配置弹窗 -->
    <schedule-dialog ref="scheduleDialog" @success="handleList"></schedule-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { comboOption } from "@/const/work/waterProof/comboOption";
import { getRootDepartmentId } from "@/api/work/waterProof/merchants";
import {
  findComboList,
  getComboDetail,
  addCombo,
  updateCombo,
  delCombo,
  findProjectList,
  findStageListByProjectId
} from "@/api/work/waterProof/combo";
import scheduleDialog from "./scheduleDialog.vue";

export default {
  name: "waterProofCombo",

  components: { scheduleDialog },

  data() {
    return {
      tableOption: comboOption,
      tableData: [],
      tableLoading: false,
      selectedIds: [],
      page: {
        total: 0,
        currentPage: 1,
        pageSize: 10
      },

      // 当前账号的顶级部门 ID
      rootDepartId: "",

      // 弹窗
      dialogVisible: false,
      dialogTitle: "新增套餐组合",
      isView: false,
      submitLoading: false,

      // 表单（字段对齐接口文档）
      comboForm: {
        id: "",
        projectId: "",
        name: "",
        childIds: [],
        sort: 0
      },

      formRules: {
        projectId: [
          { required: true, message: "请选择防水项目", trigger: "change" }
        ],
        name: [
          { required: true, message: "请输入套餐名称", trigger: "blur" }
        ],
        childIds: [
          {
            type: "array",
            required: true,
            message: "请至少选择一个阶段",
            trigger: "change",
            min: 1
          }
        ]
      },

      // 防水项目列表
      projectList: [],
      // 阶段加载中
      stageLoading: false,
      // 编辑/查看时需恢复的 childIds
      restoreChildIds: null,
      // 同步勾选过程中的锁标记，防止 selection-change 覆盖 childIds
      syncingSelection: false,
      // 所有可用阶段
      allStages: []
    };
  },

  computed: {
    ...mapGetters(["permission"]),

    /** 已选阶段（按 sort 排序） */
    selectedStages() {
      return this.allStages
        .filter((s) => this.comboForm.childIds.includes(s.id))
        .sort((a, b) => a.sort - b.sort);
    },

    /** 已选阶段合计拿货价 */
    computedTotalPrice() {
      return this.selectedStages.reduce((sum, s) => sum + Number(s.price || 0), 0);
    },

    /** 是否全选 */
    isAllStagesSelected() {
      return this.allStages.length > 0 && this.comboForm.childIds.length === this.allStages.length;
    }
  },

  created() {
    this.fetchRootDepartId().then(() => {
      this.handleList();
    });
    this.loadProjectList();
  },

  methods: {
    // ── rootDepartId ──────────────────────────────────────────

    fetchRootDepartId() {
      if (this.rootDepartId) return Promise.resolve(this.rootDepartId);
      return getRootDepartmentId()
        .then((res) => {
          this.rootDepartId = res && res.data ? res.data : "";
          return this.rootDepartId;
        })
        .catch(() => {
          this.rootDepartId = "";
          return "";
        });
    },

    // ── 数据加载 ──────────────────────────────────────────────

    /** 加载防水项目列表 */
    loadProjectList() {
      findProjectList({ page: 1, size: 500 }).then((res) => {
        if (res && res.code === "200") {
          const data = JSON.parse(res.data);
          this.projectList = data.rows || [];
        }
      });
    },

    /**
     * 切换防水项目，加载该项目的阶段列表
     * GET /joins-sales-cloud/v1/pure_water_goods/engineering_goods/{projectId}
     * 响应 data.rows[0].list → 阶段数组
     */
    handleProjectChange(projectId) {
      this.allStages = [];

      if (!projectId) {
        this.comboForm.childIds = [];
        return;
      }

      this.stageLoading = true;
      findStageListByProjectId(projectId)
        .then((res) => {
          if (!res || (res.code !== "200" && res.code !== 200)) {
            this.$message.error((res && res.message) || "获取阶段数据失败");
            return;
          }
          const parsed = JSON.parse(res.data);
          const projectData =
            parsed.rows && parsed.rows.length > 0 ? parsed.rows[0] : parsed;

          if (!projectData || !Array.isArray(projectData.list)) {
            this.allStages = [];
            return;
          }

          this.allStages = projectData.list.map((stage) => ({
            id: String(stage.id || ""),
            stageName: stage.name || "",
            price: stage.price || 0,
            threshold: stage.threshold || 0,
            sort: stage.sort || 0,
            costGrouping: stage.costGrouping || "",
            isShow: String(stage.isShow || "1"),
            formFields: (
              stage.dynamicFormRequest && stage.dynamicFormRequest.fields
                ? stage.dynamicFormRequest.fields
                : []
            ).map((f) => ({
              fieldName: f.fieldName || "",
              inputType: f.inputType || "",
              showFlag: f.showFlag || "YES"
            }))
          }));

          // 恢复已选 childIds
          if (this.restoreChildIds) {
            this.comboForm.childIds = [...this.restoreChildIds];
            this.restoreChildIds = null;
          }
          this.syncTableSelection();
        })
        .catch((err) => {
          console.error("加载阶段数据失败:", err);
          this.$message.error("加载阶段数据失败");
          this.allStages = [];
        })
        .finally(() => {
          this.stageLoading = false;
        });
    },

    /** 加载套餐列表 */
    handleList() {
      this.tableLoading = true;
      // API page 从 0 起
      const params = {
        rootDepartId: this.rootDepartId,
        page: this.page.currentPage,
        size: this.page.pageSize
      };
      findComboList(params).then((res) => {
        if (res && res.code === "200") {
          const data = JSON.parse(res.data);
          this.tableData = data.rows || [];
          this.page.total = data.total || 0;
        } else if (res && res.data) {
          // 兼容直接返回 { rows, total } 的情况
          const data = typeof res.data === "string" ? JSON.parse(res.data) : res.data;
          this.tableData = data.rows || [];
          this.page.total = data.total || 0;
        }
        this.tableLoading = false;
      }).catch(() => {
        this.tableLoading = false;
      });
    },

    // ── 分页 ──────────────────────────────────────────────

    pageSizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.page.currentPage = 1;
      this.handleList();
    },

    pageChange(page) {
      this.page.currentPage = page;
      this.handleList();
    },

    // ── 搜索 ──────────────────────────────────────────────

    searchChange(params) {
      this.tableLoading = true;
      params.rootDepartId = this.rootDepartId;
      params.page = this.page.currentPage - 1;
      params.size = this.page.pageSize;
      findComboList(params).then((res) => {
        if (res && res.code === "200") {
          const data = JSON.parse(res.data);
          this.tableData = data.rows || [];
          this.page.total = data.total || 0;
        } else {
          this.tableData = [];
        }
        this.tableLoading = false;
      }).catch(() => {
        this.tableLoading = false;
      });
    },

    searchReset() {
      this.page.currentPage = 1;
      this.handleList();
    },

    //eslint-disable-next-line
    refreshChange(page) {
      this.page.currentPage = page.currentPage || 1;
      this.page.pageSize = page.pageSize || 10;
      this.handleList();
    },

    // ── 选择 ──────────────────────────────────────────────

    handleSelectionChange(val) {
      this.selectedIds = val.map((item) => item.id);
    },

    handleSelectAllStages() {
      if (!this.$refs.stageTable) return;
      if (this.isAllStagesSelected) {
        this.$refs.stageTable.clearSelection();
      } else {
        this.allStages.forEach((row) => this.$refs.stageTable.toggleRowSelection(row, true));
      }
    },

    /** el-table selection-change 回调，同步 childIds */
    handleStageSelectionChange(selection) {
      // 同步勾选过程中不响应，避免 clearSelection 清空 childIds
      if (this.syncingSelection) return;
      this.comboForm.childIds = selection.map((s) => s.id);
    },

    /** 已选行高亮 */
    stageRowClassName({ row }) {
      return this.comboForm.childIds.includes(row.id) ? 'stage-row--selected' : '';
    },

    /** 同步 el-table 勾选状态（加锁防止 clearSelection 触发 selection-change 清空 childIds） */
    syncTableSelection() {
      this.$nextTick(() => {
        if (!this.$refs.stageTable) return;
        // 保存目标 childIds 副本，防止被中途清空
        const targetIds = [...this.comboForm.childIds];
        this.syncingSelection = true;
        this.$refs.stageTable.clearSelection();
        this.allStages.forEach((row) => {
          if (targetIds.includes(row.id)) {
            this.$refs.stageTable.toggleRowSelection(row, true);
          }
        });
        this.syncingSelection = false;
        // 确保 childIds 与实际勾选一致
        this.comboForm.childIds = [...targetIds];
      });
    },

    // ── 新增 ──────────────────────────────────────────────

    handleAdd() {
      this.dialogTitle = "新增套餐组合";
      this.isView = false;
      this.allStages = [];
      this.comboForm = {
        id: "",
        projectId: "",
        name: "",
        childIds: [],
        sort: 0
      };
      this.dialogVisible = true;
    },

    // ── 编辑 ──────────────────────────────────────────────

    handleEdit(row) {
      this.dialogTitle = "编辑套餐组合";
      this.isView = false;
      this.allStages = [];
      this.dialogVisible = true;

      // 先调用详情接口获取准确数据
      getComboDetail(row.id).then((res) => {
        const detail = res && res.data
          ? (typeof res.data === "string" ? JSON.parse(res.data) : res.data)
          : res;

        // 优先用 childIds 数组，兜底拆 concatId
        const childIds = Array.isArray(detail.childIds)
          ? detail.childIds.map((id) => String(id).trim())
          : (detail.concatId
            ? detail.concatId.split(",").map((id) => String(id).trim())
            : []);

        this.comboForm = {
          id: detail.id,
          projectId: "",
          name: detail.name || "",
          childIds: [...childIds],
          sort: detail.sort || 0
        };

        // parentId 即防水项目 ID，直接用它加载阶段
        if (detail.parentId) {
          this.loadStagesForProject(detail.parentId, childIds);
        }
      }).catch(() => {
        this.$message.error("获取套餐详情失败");
        this.dialogVisible = false;
      });
    },

    // ── 查看 ──────────────────────────────────────────────

    handleView(row) {
      this.dialogTitle = "查看套餐组合";
      this.isView = true;
      this.allStages = [];
      this.dialogVisible = true;

      getComboDetail(row.id).then((res) => {
        const detail = res && res.data
          ? (typeof res.data === "string" ? JSON.parse(res.data) : res.data)
          : res;

        const childIds = Array.isArray(detail.childIds)
          ? detail.childIds.map((id) => String(id).trim())
          : (detail.concatId
            ? detail.concatId.split(",").map((id) => String(id).trim())
            : []);

        this.comboForm = {
          id: detail.id,
          projectId: "",
          name: detail.name || "",
          childIds: [...childIds],
          sort: detail.sort || 0
        };

        if (detail.parentId) {
          this.loadStagesForProject(detail.parentId, childIds);
        }
      }).catch(() => {
        this.$message.error("获取套餐详情失败");
        this.dialogVisible = false;
      });
    },

    /**
     * 根据 parentId（防水项目 ID）直接加载阶段并恢复勾选
     * @param {String} projectId - 详情接口返回的 parentId
     * @param {String[]} childIds - 已选阶段 ID 数组（字符串）
     */
    loadStagesForProject(projectId, childIds) {
      this.comboForm.projectId = projectId;
      this.allStages = [];
      this.stageLoading = true;

      findStageListByProjectId(projectId)
        .then((res) => {
          if (!res || (res.code !== "200" && res.code !== 200)) {
            this.$message.error((res && res.message) || "获取阶段数据失败");
            return;
          }
          const parsed = JSON.parse(res.data);
          const projectData =
            parsed.rows && parsed.rows.length > 0 ? parsed.rows[0] : parsed;

          if (!projectData || !Array.isArray(projectData.list)) {
            this.allStages = [];
            return;
          }

          this.allStages = projectData.list.map((stage) => ({
            id: String(stage.id || ""),
            stageName: stage.name || "",
            price: stage.price || 0,
            threshold: stage.threshold || 0,
            sort: stage.sort || 0,
            costGrouping: stage.costGrouping || "",
            isShow: String(stage.isShow || "1"),
            formFields: (
              stage.dynamicFormRequest && stage.dynamicFormRequest.fields
                ? stage.dynamicFormRequest.fields
                : []
            ).map((f) => ({
              fieldName: f.fieldName || "",
              inputType: f.inputType || "",
              showFlag: f.showFlag || "YES"
            }))
          }));

          // 恢复已选 childIds
          this.comboForm.childIds = [...childIds];
          // el-table 用 v-if 控制，重建后需要等待渲染完毕再同步勾选
          setTimeout(() => {
            this.syncTableSelection();
          }, 150);
        })
        .catch((err) => {
          console.error("加载阶段数据失败:", err);
          this.$message.error("加载阶段数据失败");
          this.allStages = [];
        })
        .finally(() => {
          this.stageLoading = false;
        });
    },

    // ── 提交 ──────────────────────────────────────────────

    handleSubmit() {
      this.$refs.comboForm.validate((valid) => {
        if (!valid) return;

        this.submitLoading = true;

        // 构建请求体（对齐接口文档字段）
        const params = {
          name: this.comboForm.name,
          rootDepartId: this.rootDepartId,
          childIds: [...this.comboForm.childIds],
          sort: this.comboForm.sort || 0
        };

        const request = this.comboForm.id
          ? updateCombo({ id: this.comboForm.id, ...params })
          : addCombo(params);

        request
          .then((res) => {
            if (res && res.code === "200") {
              this.$message({ type: "success", message: "操作成功", showClose: true });
              this.dialogVisible = false;
              this.handleList();
            } else {
              this.$message({
                type: "error",
                message: (res && res.message) || "操作失败",
                showClose: true
              });
            }
          })
          .catch((err) => {
            this.$message({ type: "error", message: err.message || "操作异常", showClose: true });
          })
          .finally(() => {
            this.submitLoading = false;
          });
      });
    },

    // ── 配置工期 ──────────────────────────────────────────

    /** 打开阶段工期配置弹窗 */
    handleSchedule(row) {
      this.$refs.scheduleDialog.open(row);
    },

    // ── 删除 ──────────────────────────────────────────────

    /** 批量删除 */
    handleDel() {
      if (!this.selectedIds.length) {
        this.$message({ showClose: true, message: "请选择要操作的套餐", type: "error" });
        return;
      }
      this.$confirm("是否确认删除所选套餐组合？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          // 接口为单条删除，批量时逐条调用
          const promises = this.selectedIds.map((id) => delCombo(id));
          return Promise.all(promises);
        })
        .then(() => {
          this.$message({ type: "success", message: "删除成功", showClose: true });
          this.handleList();
        })
        .catch(() => {});
    },

    /** 单行删除 */
    handleDelRow(row) {
      this.$confirm(`确认删除套餐「${row.name}」？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          delCombo(row.id).then((res) => {
            if (res && res.code === "200") {
              this.$message({ type: "success", message: "删除成功", showClose: true });
              this.handleList();
            } else {
              this.$message({ type: "error", message: (res && res.message) || "删除失败", showClose: true });
            }
          });
        })
        .catch(() => {});
    },

    // ── 弹窗关闭 ──────────────────────────────────────────

    handleDialogClose() {
      this.$refs.comboForm && this.$refs.comboForm.resetFields();
    }
  }
};
</script>

<style lang="scss" scoped>
/* ── 阶段面板 ──────────────────────────────────────── */
.stage-panel {
  width: 100%;
  border: 1px solid #dcdfe6;
  border-radius: 6px;
  overflow: hidden;
  background: #fff;
}

.stage-panel__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 14px;
  background: #f5f7fa;
  border-bottom: 1px solid #ebeef5;
  font-size: 13px;
  color: #606266;
}

.stage-panel__header-left {
  display: flex;
  align-items: center;
  gap: 6px;

  i {
    font-size: 15px;
    color: #409eff;
  }
}

.stage-panel__empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 36px 0;
  color: #c0c4cc;

  i {
    font-size: 36px;
    margin-bottom: 8px;
  }

  p {
    margin: 0;
    font-size: 13px;
  }
}

.stage-panel__loading {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 36px 0;
  color: #409eff;
  font-size: 13px;

  i {
    font-size: 18px;
  }
}

.stage-panel__footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 14px;
  background: #f0f9ff;
  border-top: 1px solid #e1f3f8;
  font-size: 13px;
  color: #606266;
}

.stage-panel__count b {
  color: #409eff;
}

.stage-panel__total-price {
  font-size: 18px;
  font-weight: 700;
  color: #409eff;
  margin-left: 4px;
}

/* ── 阶段行内样式 ─────────────────────────────────── */
.stage-row__name {
  display: flex;
  align-items: center;
  gap: 8px;
}

.stage-row__sort-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #409eff;
  color: #fff;
  font-size: 11px;
  font-weight: 600;
  flex-shrink: 0;
}

.stage-row__price {
  color: #e6a23c;
  font-weight: 600;
}

.stage-row__field-count {
  color: #909399;
  font-size: 12px;
}
</style>

<style lang="scss">
/* 已选行高亮（非 scoped，el-table row-class 需要全局） */
.stage-row--selected td {
  background-color: #ecf5ff !important;
}
</style>
